import LoginModal from './login-modal';

export default LoginModal;
